/* joechia-style price formatter for YA|SAR (v2 — text-node safe)
 * Removes ",00" decimal padding and trailing currency code (IDR/USD/EUR/...)
 * Walks ONLY text nodes so we don't destroy visually-hidden a11y labels
 * inside the price container.
 */
(function () {
  'use strict';

  var CURRENCY_CODES = /\s+(IDR|USD|EUR|GBP|VND|MYR|SGD|JPY|AUD|CAD|CNY|HKD|KRW|NZD|RUB|THB|CHF|SEK|NOK|DKK|PLN|TRY|BRL|MXN|ZAR|INR|AED|SAR|TWD|PHP)\s*(?=\s|$)/gi;
  var DECIMAL_PAD = /(\d)[,.]00(?=\D|$)/g;

  var CONTAINER_SELECTOR = '.m-price, .m-price-item, .m-product-card__price, .money, [data-product-price]';

  function cleanPriceText(text) {
    if (!text) return text;
    var out = text.replace(DECIMAL_PAD, '$1');
    out = out.replace(CURRENCY_CODES, '');
    return out.replace(/\s{2,}/g, ' ');
  }

  function processTextNodesIn(container) {
    if (!container || !container.nodeType) return;
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var orig = node.nodeValue;
      if (!orig) continue;
      var cleaned = cleanPriceText(orig);
      if (cleaned !== orig) node.nodeValue = cleaned;
    }
  }

  function processPrices(root) {
    if (!root) root = document;
    var nodes = root.querySelectorAll ? root.querySelectorAll(CONTAINER_SELECTOR) : [];
    for (var i = 0; i < nodes.length; i++) processTextNodesIn(nodes[i]);
  }

  var observer;
  function safeProcess() {
    if (observer) observer.disconnect();
    try { processPrices(document); }
    finally { if (observer) observer.observe(document.body, { childList: true, subtree: true, characterData: true }); }
  }

  function init() {
    processPrices(document);
    observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.addedNodes && m.addedNodes.length) { safeProcess(); return; }
        if (m.type === 'characterData') { safeProcess(); return; }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', safeProcess);
  document.addEventListener('shopify:section:select', safeProcess);
  window.addEventListener('currencies:update', safeProcess);
})();
